import React from 'react';

interface Props { bgImage?: string; }

export const Slide4Journey: React.FC<Props> = ({ bgImage }) => (
  <div className="bs-slide-inner">
    <div className="bs-slide-bg" aria-hidden="true">
      {bgImage ? (
        <div
          className="bs-slide-bg-img"
          style={{ backgroundImage: `url(${bgImage})` }}
        />
      ) : (
        <div className="bs-slide-bg--journey-fallback" />
      )}
      <div className="bs-overlay bs-overlay--heavy" />
    </div>

    <div className="bs-content">
      <span className="bs-label">JOURNEYS</span>
      <h1 className="bs-headline">
        Some experiences can't be bought online.
      </h1>
      <p className="bs-subline">Until now.</p>
    </div>
  </div>
);
